<mwe-empty-state
  staticImage="add-products.svg"
  [headlineText]="emptyTitle()"
  [messageKeys]="[emptyText()]"
  ctaLabel="products-add.title"
  (onCtaClick)="onAddProductBtnClicked()"
  cta2Label="products.orderProducts.entry"
  (onCta2Click)="onOrderProductBtnClicked()"
/>
